export default {
  COMPONENT: "COMPONENT",
  SHAPE: "SHAPE"
};
